(function ($) {
  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return (
        navigator.userAgent.match(/IEMobile/i) ||
        navigator.userAgent.match(/WPDesktop/i)
      );
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };
  var records_per_page = 5;

  // SEETICKETS
  $("body").on("click", "#btn_prev", function prevPage(e) {
    e.preventDefault();
    var current_page = $(
      "#event-search-results-container .wpb_wrapper:eq(0) table:first tbody"
    ).data("page");

    if (current_page > 1) {
      current_page--;
      changePage(current_page);
    }
  });

  $("body").on("click", "#btn_next", function nextPage(e) {
    e.preventDefault();
    var current_page = $(
      "#event-search-results-container .wpb_wrapper:eq(0) table:first tbody"
    ).data("page");
    var totalPages = $(
      "#event-search-results-container .wpb_wrapper:eq(0) table:first tbody"
    ).data("totalPages");

    if (current_page < totalPages) {
      current_page++;
      changePage(current_page);
    }
  });

  function changePage(page) {
    var btn_next = document.getElementById("btn_next");
    var btn_prev = document.getElementById("btn_prev");
    var listing_table = $(
      "#event-search-results-container .wpb_wrapper:eq(0) table:first tbody"
    );
    var rows = listing_table.data("rows");

    listing_table.html("");

    // Validate page
    if (page < 1) page = 1;
    if (page > numPages(rows)) page = numPages(rows);

    for (
      var i = (page - 1) * records_per_page;
      i < page * records_per_page;
      i++
    ) {
      listing_table.append(rows[i]);
      //console.log(i, rows[i]);
    }

    if (page == 1) {
      btn_prev.style.visibility = "hidden";
    } else {
      btn_prev.style.visibility = "visible";
    }

    if (page == numPages(rows)) {
      btn_next.style.visibility = "hidden";
    } else {
      btn_next.style.visibility = "visible";
    }

    listing_table.data("page", page);
  }

  function numPages(rows) {
    return Math.ceil(rows.length / records_per_page);
  }

  $("#event-search-container form").on("submit", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#event-search-results-container .wpb_wrapper:eq(0)").html(
      '<table class="table "><tbody></tbody></table>'
    );
    $("#event-search-container .vc_grid-loading").show();

    $.ajax({
      url: settings.ajax_url,
      type: "post",
      dataType: "json",
      error: function () {
        $("#event-search-container .vc_grid-loading").hide();
      },
      data: {
        action: "post_search_tickets",
        data: $(this).serialize(),
      },
      success: function (data) {
        var pager = $("<div/>");
        pager.html(data.data);

        var rows = [];
        pager.find("table tr").each(function (k, e) {
          rows.push("<tr>" + $(e).html() + "</tr>");
        });

        if (data.data == '<table class="table "><tbody></tbody></table>') {
          $("#event-search-results-container .wpb_wrapper:eq(0)").html(
            "The date you have selected isn’t available"
          );
        }

        var pager = $("<table/>").addClass("table");
        pager.html(
          '<tr><td class="text-left"><a href="#" id="btn_prev" class="pull-left">Prev</a></td><td class="text-right"><a href="#" id="btn_next">Next</a></td></tr>'
        );

        $("#event-search-results-container .wpb_wrapper:eq(0)").append(pager);

        $("#event-search-container .vc_grid-loading").hide();

        $(
          "#event-search-results-container .wpb_wrapper:eq(0) table:first tbody"
        ).data("rows", rows);
        $(
          "#event-search-results-container .wpb_wrapper:eq(0) table:first tbody"
        ).data("totalPages", numPages(rows));
        changePage(1);
      },
    });
  });

  // END SEETICKETS

  //SPEKTRIX
  const _spektrixHash = "#tickets";
  const _registerHash = "#register";
  const _toggleNextSiblings = (element, state) => {
    while ((element = element.next())) {
      if (!element.length) break;

      element.toggle(state);
    }
  };

  const _getTopRowComponent = (element, callback) => {
    let parent;
    let buster = 25;

    callback = callback || ((element) => element.is("main"));

    while ((parent = element.parent())) {
      if (!buster-- || !parent.length || callback(parent)) return element;

      element = parent;
    }

    return element;
  };

  const _pushAnchorState = (anchor) => {
    if (history && "pushState" in history) {
      const url = window.location.pathname + window.location.search + anchor;
      history.pushState("", document.title, url);
    }
  };

  const _showSpektrixTicketScreen = (event, hash) => {
    event && event.preventDefault();
    let event_id = false;
    if(hash.includes("_")){
        event_id = hash.split("_").pop();
    }
    let ticketComponent;
    if(event_id) {
        ticketComponent = $("#buy_tickets_component_" + event_id);
    }
    else{
        ticketComponent = $("#buy_tickets_component");
        $(".breadcrumbs").addClass("d-none");
        $("#event_content").addClass("d-none");
    }
    
    if (ticketComponent.find(".api_component").length > 0) {
      ticketComponent
        .find(".api_component")
        .css({
          "z-index": "10",
          display: "block",
        })
        .removeClass("d-none");
      ticketComponent
        .css({
          "z-index": "10",
          display: "block",
        })
        .removeClass("d-none");
      ticketComponent.find("#select_tickets").removeClass("d-none");
    } else if (ticketComponent.find("iframe").length > 0) {
      const frameSource = ticketComponent.find("iframe").data("src");

      const iframe = ticketComponent.find("iframe");
      iframe.removeClass("loaded");
      iframe.on("load", (e) => e.target.classList.add("loaded"));
      if (ticketComponent.find(".iframe-wrapper").hasClass("load_manually")) {
        ticketComponent
          .css({
            "z-index": "10",
            display: "block",
          })
          .removeClass("d-none");
      } else {
        ticketComponent
          .css({
            "z-index": "10",
            display: "block",
          })
          .removeClass("d-none")
          .find("iframe")
          .attr("src", frameSource);
      }
    } else {
      ticketComponent
        .css({
          "z-index": "10",
          display: "block",
        })
        .removeClass("d-none");
    }
    _toggleNextSiblings(ticketComponent, false);
    _pushAnchorState(hash);
    $("main.content>.vc_row>.wpb_column .vc_empty_space").css({ height: 300 });
    $(".banner_anchor").hide();
  };
  
  const _insertCSS = (e) => {
    if (document.body.classList.contains("postid-87100")) {
      _iframeCSSInserter(
        `${window.location.hostname}/wp-content/themes/ap/asstes/spektrix/spektrix_hide_message.css`
      );
    }
    // e.currentTarget.removeEventlistener('load',_insertCSS);
  };
  const _iframeCSSInserter = (link) => {
    let cssLink = document.createElement("link");
    cssLink.href = link;
    cssLink.rel = "stylesheet";
    cssLink.type = "text/css";
    frames["SpektrixIFrame"].document.head.appendChild(cssLink);
  };

  const _hideSpektrixTicketScreen = (event) => {
    event && event.preventDefault();
    let ticketComponent = $("#buy_tickets_component");
    if (!ticketComponent.length) {
      ticketComponent = $(".buy_tickets_component");
    }
    $("#event_content").removeClass("d-none");
    $(".breadcrumbs").removeClass("d-none");
    ticketComponent.addClass("d-none").find("iframe").attr("src", "");
    ticketComponent.find("iframe").removeClass("loaded");
    _toggleNextSiblings(ticketComponent, true);
    _pushAnchorState("");
    $("main.content>.vc_row>.wpb_column .vc_empty_space").css({ height: 300 });
    $(".banner_anchor").show();
  };

  const showSpektrixScreen = (state = true, event = null) => {
    let hash;
    if (state) {
      hash = `#${event.target.href?.split("#").pop()}`;
      _showSpektrixTicketScreen(event, hash);
    } else {
      _hideSpektrixTicketScreen(event);
    }
    if (hash == _registerHash) {
      document.querySelector(".tagged-sign-up-component")?.scrollIntoView();
    }
  };
  $("body")
    // We're specifically only binding to <button> tags here,
    // as the HTML element will render as an <a> tag instead
    // if we provide it with an target URL.
    .on("click", "#back-to-event-btn button", (event) =>
      showSpektrixScreen(false, event)
    )
    .on("click", ".btn.spektrix-ticket", (event) =>
      showSpektrixScreen(true, event)
    );

  window.addEventListener("hashchange", function (e) {
    const hash = window.location.hash || "#";

    if (hash.includes(_spektrixHash)) {
      _showSpektrixTicketScreen(e, hash);
      let hashElement = document.querySelector(hash)
      if(!hashElement){
        let event_id = hash.split("_").pop();
        if (event_id) {
          hashElement = document.querySelector(`#buy_tickets_component_${event_id}`);
        }
      }
      hashElement?.scrollIntoView();

      return false;
    } else if (hash.indexOf(_registerHash) !== -1) {
      _showSpektrixTicketScreen(e, _registerHash);
      document.querySelector(".tagged-sign-up-component")?.scrollIntoView();
      return false;
    } else if (hash === "#") {
      _hideSpektrixTicketScreen();
      return false;
    }

    // If we get here, we have a non-empty hash which _isn't_
    // the spektrix trigger, so we just want that to behave as
    // normal.
    return true;
  });

  let scrollOnIframeLoaded = false;

  window.onSpektrixIframeLoad = function (event) {
    if (!scrollOnIframeLoaded) {
      return true;
    }

    const header = $("#site_header");
    const iframe = $(
      event.target || (event.path || []).shift() || "#SpektrixIframe"
    );

    const headerOffset = header.outerHeight();
    const iframeOffset = iframe.offset().top;
    const iframeMargin = parseInt(iframe.css("margin-top"));
    let totalOffset = Math.max(
      0,
      // Start with the iframe height
      (iframeOffset || 0) +
        // Then _add_ the margin, as it's a negative value
        (iframeMargin || 0) -
        // Then subtract the width of the header to reduce
        // the amount of scroll (we want to stop higher up the
        // page than the actual iframe top).
        (headerOffset || 0)
    );

    // If the source has been removed, then we want to treat it like an
    // entirely new page and go to the top, rather than the iframe position
    if (!iframe.attr("src")) totalOffset = 0;

    console.log("scroll breakdown", {
      "iframe-offset": iframeOffset,
      "iframe-margin": iframeMargin,
      "header-offset": headerOffset,
      "total-offset": totalOffset,
    });

    if (iframe.attr("src"));

    window.scrollTo(0, totalOffset);
    window.addEventListener("load", () => {
      //Some nasty thing I can't trace keeps scrolling back to top. This is a hack to fix it.
      setTimeout(() => {
        window.scrollTo(0, totalOffset);
      }, 500);
    });
    return true;
  };

  $(document).ready(() => {
    /* If we dispatch this at page load time, the styling on the container is off and the iframe content
     * is pushed to the side of the screen. I suspect something is attempting to calculate some positional
     * data before a dom element has width. The div #buy_tickets_component ends up with a <1500px padding-right
     * (1875px on my laptop screen).
     *
     * Update: 2021-12-15.
     * By using the 50ms timeout, we get around the weird resize issue.
     *
     */
    setTimeout(() => {
      window.dispatchEvent(new Event("hashchange"));
    }, 50);

    /*
     * We don't want to scroll to the iframe on the very initial load.
     * So we'll set this to 'unlock' just after the page has loaded.
     */
    setTimeout(() => {
      if (
        window.location.pathname.indexOf("basket") === -1 ||
        window.location.pathname.indexOf("checkout") === -1
      ) {
        scrollOnIframeLoaded = true;
      }
    }, 1000);
  });

  //in page buy tickets for random event
  //$('body').on('click', '.book-now-btn-page button', (e) => _showBuyTicketsRow(e) );

  //END SPEKTRIX

  // Sticky nav
  $(window).on("scroll touchmove", function () {
    $("#site_header").toggleClass("sticky", $(document).scrollTop() > 100);
  });

  $("body").search();

  equalheight = function (container) {
    var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
    $(container).each(function () {
      $el = $(this);
      $($el).height("auto");
      topPostion = $el.position().top;

      if (currentRowStart != topPostion) {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPostion;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest =
          currentTallest < $el.height() ? $el.height() : currentTallest;
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  };

  $(window).load(function () {
    equalheight(
      "#hp_events_carousel .event_carousel_info .vc_gitem-row-position-top, #events-container .event_item .event_details, .events_carousel .event_carousel_info .vc_gitem-zone-mini .vc_gitem-row-position-top, .stories_grid .event_carousel_info .vc_gitem-row-position-top"
    );

    // if($('#hp_hero').length && !/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ){
    //     var video = $('<video/>');
    //     video.get(0).autoplay = true;
    //     video.get(0).muted = true;
    //     video.get(0).loop = true
    //     var src = $('<source/>').attr('src', 'https://assets.alexandrapalace.com/video/ap-header.mp4').attr('type',"video/mp4");
    //     video.append(src);
    //
    //
    //     video.get(0).oncanplay = function() {
    //         $('#hp_hero').append(video);
    //         video.fadeIn();
    //     };
    //
    // }
  });

  $(window).resize(function () {
    equalheight(
      "#hp_events_carousel .event_carousel_info .vc_gitem-row-position-top, #events-container .event_item .event_details, .events_carousel .event_carousel_info .vc_gitem-zone-mini .vc_gitem-row-position-top, .stories_grid .event_carousel_info .vc_gitem-row-position-top"
    );
  });

  $(document).ready(function () {
    // Remove title tag attribute on hover
    $("[title]").removeAttr("title");

    // Select2
    $("select.dhvc-form-control, #survey").each(function (k, e) {
      $(e).select2({
        placeholder: $(e).attr("placeholder"),
        minimumResultsForSearch: -1,
        dropdownParent: $(e).closest(".vc_row-fluid"),
      });
    });

    $("#survey").select2({
      dropdownParent: $(".seat_select"),
      minimumResultsForSearch: -1,
    });

    $(".event_item_footer").append($(""));

    if ($.fn.datetimepicker) {
      $("#date-from").each(function (k, e) {
        $(e).datetimepicker({
          i18n: {
            en: {
              dayOfWeekShort: ["S", "M", "T", "W", "T", "F", "S"],
            },
          },
        });
      });
    }

    // // Subnav
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
    ) {
      var container = $(".sub-nav"),
        scrollTo = $(".sub-nav").find(".active");

      if (container.length && scrollTo.length) {
        container.animate(
          {
            scrollLeft:
              scrollTo.offset().left -
              container.offset().left +
              container.scrollLeft(),
          },
          0
        );
      }
    }
    // var container = $('.sub-nav'),
    // scrollTo = $('.sub-nav').find('.active');
    //
    // if(container.length && scrollTo.length) {
    //     container.animate({
    //         scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
    //     }, 0);
    // }
    // How to overwrite the form errors

    // $("form.dhvcform").each(function(k, e){
    //     $(e).validate().settings.errorElement = 'p';
    //     $(e).validate().settings.errorPlacement = function(error, element) {
    //         element.parents("div.dhvc-form-group").addClass('error');
    //         error.appendTo( element.parents("div.dhvc-form-group").find('label'));
    //     };
    //     $(e).validate().settings.success = function(label,element) {
    //         label.parent().removeClass('error');
    //         label.remove();
    //         $(element).parent().parent().removeClass('error');
    //         $(element).parent().parent().find('p.error').remove();
    //     };
    // });

    //newsletter signup form
    $("body").on("change", '[type="checkbox"]', function (e) {
      var _el = $(e.target);
      var text = _el.parents(".dhvc-form-checkbox").text().toLowerCase();

      if (_el.attr("name").indexOf("wrapper") === -1) {
        return;
      }

      if (text.indexOf("music") !== -1) {
        if (_el.is(":checked")) {
          $(".music-items").removeClass("hidden");
        } else {
          $(".music-items").addClass("hidden");
        }
      } else if (text.indexOf("theatre") !== -1) {
        if (_el.is(":checked")) {
          $(".theatre-items").removeClass("hidden");
        } else {
          $(".theatre-items").addClass("hidden");
        }
      } else if (text.indexOf("live") !== -1) {
        if (_el.is(":checked")) {
          $(".live-events-item").removeClass("hidden");
        } else {
          $(".live-events-item").addClass("hidden");
        }
      } else if (text.indexOf("venue") !== -1) {
        if (_el.is(":checked")) {
          $(".venue-hire-item").removeClass("hidden");
        } else {
          $(".venue-hire-item").addClass("hidden");
        }
      }
    });

    // ADD SLIDEDOWN ANIMATION TO DROPDOWN //
    $(".dropdown").on("show.bs.dropdown", function (e) {
      $(this).find(".dropdown-menu").first().stop(true, true).slideDown();
    });

    // ADD SLIDEUP ANIMATION TO DROPDOWN //
    $(".dropdown").on("hide.bs.dropdown", function (e) {
      e.preventDefault();
      $(this)
        .find(".dropdown-menu")
        .first()
        .stop(true, true)
        .slideUp(400, function () {
          //On Complete, we reset all active dropdown classes and attributes
          //This fixes the visual bug associated with the open class being removed too fast
          $(".dropdown").removeClass("show");
          $(".dropdown-menu").removeClass("show");
          $(".dropdown")
            .find(".dropdown-toggle")
            .attr("aria-expanded", "false");
        });
    });

    $("#charity-checkout-donation-modal").on("show.bs.modal", function () {
      $("html, body").css({ overflow: "hidden" });
      console.log("lock page scroll");
      $(this)
        .find(".modal-body")
        .html(
          '<iframe id="checkout-iframe" frameborder="0" scrolling="no" src="https://alexandrapalace.charitycheckout.co.uk/page369d8" style="width: 100%; border: medium none; height: 100%; position: absolute; top:0; left: 0; overflow: auto;" scrolling="yes"></iframe><script type="text/javascript">!function(e,t,c){var a,r=e.getElementsByTagName(t)[0];e.getElementById(c)||(a=e.createElement(t),a.id=c,a.src="https://app.charitycheckout.co.uk/bundles/scripts/iframe?d="+Date.now(),r.parentNode.insertBefore(a,r))}(document,"script","checkout-js");</script>'
        );
    });

    $("#charity-checkout-donation-modal").on("hidden.bs.modal", function () {
      $(this).find(".modal-body").html("");
      $("html, body").css({ overflow: "auto" });
    });

    $("#charity-checkout-donor-board-modal").on("show.bs.modal", function () {
      console.log("lock page scroll");
      $("html, body").css({ overflow: "hidden" });
      $(this)
        .find(".modal-body")
        .html(
          '<iframe id="checkout-iframe" frameborder="0" scrolling="no" src="https://alexandrapalace.charitycheckout.co.uk/donate"  style="width: 100%; border: medium none; height: 100%; position: absolute; top:0; left: 0; overflow: auto;" scrolling="yes"></iframe><script type="text/javascript">!function(e,t,c){var a,r=e.getElementsByTagName(t)[0];e.getElementById(c)||(a=e.createElement(t),a.id=c,a.src="https://app.charitycheckout.co.uk/bundles/scripts/iframe?d="+Date.now(),r.parentNode.insertBefore(a,r))}(document,"script","checkout-js");</script>'
        );
    });

    $("#charity-checkout-donor-board-modal").on("hidden.bs.modal", function () {
      $(this).find(".modal-body").html("");
      $("html, body").css({ overflow: "auto" });
    });

    $("#charity-checkout-theatre-tour-modal").on("show.bs.modal", function () {
      $("html, body").css({ overflow: "hidden" });
      $(this)
        .find(".modal-body")
        .html(
          '<iframe id="checkout-iframe" frameborder="0" scrolling="no" src="https://alexandrapalace.charitycheckout.co.uk/pagebb186"  style="width: 100%; border: medium none; height: 100%; position: absolute; top:0; left: 0; overflow: auto;" scrolling="yes"></iframe><script type="text/javascript">!function(e,t,c){var a,r=e.getElementsByTagName(t)[0];e.getElementById(c)||(a=e.createElement(t),a.id=c,a.src="https://app.charitycheckout.co.uk/bundles/scripts/iframe?d="+Date.now(),r.parentNode.insertBefore(a,r))}(document,"script","checkout-js");</script>'
        );
    });

    $("#charity-checkout-theatre-tour-modal").on(
      "hidden.bs.modal",
      function () {
        $(this).find(".modal-body").html("");
        $("html, body").css({ overflow: "auto" });
      }
    );

    $(".venue_btn").click(function () {
      if ($(this).hasClass("ice_rink")) {
        $(".dhvc-form-control-ice-rink").prop("checked", true);
      }

      if ($(this).hasClass("park")) {
        $(".dhvc-form-control-park").prop("checked", true);
      }

      if ($(this).hasClass("east_court")) {
        $(".dhvc-form-control-east-court").prop("checked", true);
      }

      if ($(this).hasClass("palm_court")) {
        $(".dhvc-form-control-palm-court").prop("checked", true);
      }

      if ($(this).hasClass("londesborough")) {
        $(".dhvc-form-control-londesborough-room").prop("checked", true);
      }

      if ($(this).hasClass("palace_suite")) {
        $(".dhvc-form-control-palace-suite").prop("checked", true);
      }
      if ($(this).hasClass("panorama")) {
        $(".dhvc-form-control-panorama-room").prop("checked", true);
      }

      if ($(this).hasClass("theatre")) {
        $(".dhvc-form-control-theatre").prop("checked", true);
      }

      if ($(this).hasClass("west_hall")) {
        $(".dhvc-form-control-west-hall").prop("checked", true);
      }

      if ($(this).hasClass("great_hall")) {
        $(".dhvc-form-control-great-hall").prop("checked", true);
      }
    });

    //sliding to doors open table
    $("#door-open-table-link").on("click", function () {
      var top = $("#doors-opening-times").offset().top - 140;

      $("html, body").animate({
        scrollTop: top,
      });
    });

    //tooltips
    $('[data-toggle="tooltip"]').tooltip();

    $(".go-to-support").on("click", function () {
      if (window.location.pathname.indexOf("support-us/overview") > 0) {
        var top = $("#checkout-iframe").offset().top - 140;

        $("html, body").animate({
          scrollTop: top,
        });
      } else {
        window.location.pathname = "/support-us/overview/";
      }
    });

    $(".go-to-terrace-intro").on("click", function () {
      window.location.href =
        "https://" +
        window.location.host +
        "/the-terrace/book-now/" +
        encodeURI("#") +
        "terrace";
    });

    $(".go-to-live").on("click", function () {
      window.location.href =
        "https://www.alexandrapalace.com/live-at-ally-pally/book-now/";
    });

    if (
      window.location.pathname.indexOf("the-terrace/book-now") > 0 &&
      window.location.hash == "#terrace"
    ) {
      setTimeout(function () {
        var top = $("#terrace_intro").offset().top - 300;

        $("html, body").animate({
          scrollTop: top,
        });
      }, 1000 * 1);
    }

    $(".go-to-golden-ticket").on("click", function () {
      window.location.href =
        "https://" + window.location.host + "/golden-ticket/";
    });

    $(".go-to-christmas").on("click", function () {
      window.location.href =
        "https://" + window.location.host + "/christmas/allypallychristmas/";
    });
  });

  var popupInterval = null;

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function checkCookie(name) {
    if (getCookie(name)) {
      return true;
    } else {
      return false;
    }
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /* setTimeout(function(){
        //console.log('starting script');
        popupInterval = window.setInterval(function(){
            //console.log('Quancast exists: '+$('body').hasClass('qc-cmp-ui-showing'))

            if(!$('body').hasClass('qc-cmp-ui-showing')){
                if(!checkCookie('donation-popup') && window.location.pathname.indexOf('support-us/overview') === -1){
                    setTimeout(function(){
                        $('#donation-footer-popup').animate({bottom: 0});

                        $('#donation-footer-popup .btn-close, #donation-footer-popup .ap-btn-pink').on('click', function( event ){
                            event.preventDefault();
                            $('#donation-footer-popup').animate({bottom: '-700px'});
                            setCookie('donation-popup', 1, 1);
                        });
                    }, 5* 1000);
                    // console.log('no cookie');
                }

                window.clearInterval(popupInterval);
            }
        }, 500);
    }, 4* 1000); */

  let flashBanner = document.querySelector(".flash_banner");
  if (flashBanner) {
    document.documentElement.style.setProperty(
      "--banner-height",
      `${flashBanner.clientHeight}px`
    );
  }
  let content = document.querySelector(".content");
  let header = document.querySelector(".header_container");
  if (header && content) {
    headerHeight = header.clientHeight;
    if (flashBanner) {
      headerHeight += flashBanner.clientHeight;
      content.style.paddingTop = `${headerHeight}px`;
    }
    
  }
  const closeFlash = document.querySelector(".flash_banner button");
  if (closeFlash) {
    closeFlash.addEventListener("click", function () {
      flashBanner.style.display = "none";
      document.body.classList.remove("pre-header");
      headerHeight = header.clientHeight;
      content.style.paddingTop = `${headerHeight}px`;
      const date = new Date();
      date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
      document.cookie =
        "pre-header-closed=1; expires=" + date.toUTCString() + "; path=/";
    });
  }

  $(document).on('gform_post_render', function () {
    // AJAX-enabled forms will call gform_post_render again when rendering new pages or validation errors.
    // We need to reset our flag so that we can still do our focus action when the form conditional logic
    // has been re-evaluated.
    window['gwfef'] = false;
    var hasError = gwFirstErrorFocus().length;
    

    var onSubsequentPage = $('.gf_step_current_page') && $('.gf_step_current_page').text() > 1;
    if (!hasError && onSubsequentPage) {
      requestAnimationFrame(function() {
        window.scrollTo(0, $('.gform_wrapper').offset().top);
      });
    }
    var hasConfirmation = $('.gform_confirmation_wrapper').length;
    if (hasConfirmation) {
      requestAnimationFrame(function() {
        window.scrollTo(0, $('.gform_confirmation_wrapper').offset().top);
      });
    }
  });
  $(document).on('gform_post_conditional_logic', function (event, formId, fields, isInit) {
    if (!window['gwfef'] && fields === null && isInit === true) {
      gwFirstErrorFocus();
      window['gwfef'] = true;
    }
  });

  function gwFirstErrorFocus() {
    var $firstError = $('.gfield.gfield_error:visible:first');
    if ($firstError.length > 0) {
      // Without setTimeout or requestAnimationFrame, window.scroll/window.scrollTo are not taking
      // effect on iOS and Android.
      requestAnimationFrame(function () {
        window.scrollTo(0, $firstError.offset().top);
        $firstError.find('input, select, textarea').eq(0).focus();
      });
    }

    return $firstError;
  }

 

})(jQuery);


